<template>
<div>

<v-card :min-width="`${ this.$vuetify.breakpoint.smAndDown ? 'unset' : '600px' }`">
	<v-card-title class="primary--text">
		<span>{{ course != null ? 'MODIFICA CORSO' : 'AGGIUNGI CORSO'}}</span>
		<v-spacer></v-spacer>
		<v-icon @click="closeCourseDialog()">mdi-close</v-icon>
	</v-card-title>
	<v-card-text>
		<v-form ref="courseDataForm">
			<v-text-field
				label="Nome *"
				v-model="name"
				autocomplete="nope" 
				outlined
				dense
				:rules="[rules.required]"
			></v-text-field>
			<v-select
				label="Categoria"
				:items="categories"
				item-text="Nome"
				item-value="idCategoria"
				v-model="category"
				outlined
				dense
				:rules="[rules.required]"
				:loading="isLoadingCategories"
				return-object
			></v-select>
			<!-- <v-text-field
				label="Note sul corso"
				v-model="note"
				autocomplete="nope" 
				outlined
				dense
				:loading="isLoadingCourse"
			></v-text-field> -->
			<div>* Campo obbligatorio</div>
		</v-form>
	</v-card-text>
	<v-card-actions>
		<!-- <v-btn v-if="env == 'local'" @click="logga()" color="success" class="ml-2">Logga</v-btn> -->
		<v-btn v-if="course != null" @click="openDeleteCourseDialog()" color="error" class="ml-2">Elimina</v-btn>
		<v-spacer></v-spacer>
		<v-btn @click="closeCourseDialog()" :class="`mb-3 mr-2 ${getSecondaryTextColorClass()}`" color="secondary">Annulla</v-btn>
		<v-btn @click="openSaveCourseDialog()" class="mb-3 mr-2" color="primary">Salva</v-btn>
	</v-card-actions>
</v-card>

<v-dialog
	v-model="saveCourseDialog"
	:max-width="`${ this.$vuetify.breakpoint.smAndDown ? 'unset' : '400px' }`"
>
	<v-card>
		<v-card-title>

		</v-card-title>
		<v-card-text>
			<v-container>
				<v-row class="flex-column secondary--text" :style="`font-size: 18px; font-weight:500;`">
					<p v-if="!courseSaved && !isSavingCourse">
						<span v-if="course == null">Vuoi aggiungere il corso?</span>
						<span v-if="course != null">Vuoi salvare le modifiche?</span>
					</p>
          <p v-if="isSavingCourse">
						<span v-if="course == null">Aggiunta in corso...</span>
						<span v-if="course != null">Salvataggio in corso...</span>
          </p>
          <v-progress-linear
            v-if="isSavingCourse"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <p v-if="!isSavingCourse && courseSaved">
						<span v-if="course == null">Corso aggiunto!</span>
						<span v-if="course != null">Le modifiche sono state salvate!</span>
          </p>
				</v-row>
			</v-container>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn v-if="!courseSaved && !isSavingCourse" @click="saveCourseDialog = false" :class="`mb-3 ${getSecondaryTextColorClass()}`" color="secondary">Annulla</v-btn>
			<v-btn v-if="!courseSaved && !isSavingCourse" @click="saveCourse()" class="mb-3" color="primary">
				<span v-if="course == null">Si</span>
				<span v-if="course != null">Salva</span>
			</v-btn>
			<v-btn v-if="courseSaved" class="mb-3" color="primary" @click="closeSaveCourseDialog(), closeCourseDialog()">Ok</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>

<v-dialog
	v-model="deleteCourseDialog"
	:max-width="`${ this.$vuetify.breakpoint.smAndDown ? 'unset' : '400px' }`"
	persistent
>
	<v-card>
		<v-card-title>

		</v-card-title>
		<v-card-text>
			<v-container>
				<v-row class="flex-column secondary--text" :style="`font-size: 18px; font-weight:500;`">
					<p v-if="!courseDeleted && !isDeletingCourse">
						Vuoi eliminare il corso?
					</p>
          <p v-if="isDeletingCourse">
						Eliminazione in corso...
					</p>
          <v-progress-linear
            v-if="isDeletingCourse"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <p v-if="!isDeletingCourse && courseDeleted">
						Corso eliminato!
					</p>
				</v-row>
			</v-container>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn v-if="!courseDeleted && !isDeletingCourse" @click="deleteCourseDialog = false" :class="`mb-3 ${getSecondaryTextColorClass()}`" color="secondary">Annulla</v-btn>
			<v-btn v-if="!courseDeleted && !isDeletingCourse" @click="deleteCourse()" class="mb-3" color="primary">Si</v-btn>
			<v-btn v-if="courseDeleted" class="mb-3" color="primary" @click="closeDeleteCourseDialog(), closeCourseDialog()">Ok</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>

</div>
</template>

<script>
import mixin from '../mixin';
	export default {
		mixins: [mixin],
		props: ['course'],
		data() {
			return {
				// env: 'production',
				isLoadingCourse: false,
				isLoadingCategories: false,

				name: null,

				categories: [],
				category: null,

				// note: null,

				// dialog salvataggio
				saveCourseDialog: false,
				isSavingCourse: false,
				courseSaved: false,

				// dialog eliminazione
				deleteCourseDialog: false,
				isDeletingCourse: false,
				courseDeleted: false,
			}
		},

		watch: {
			// course: {
			// 	handler() {
			// 		// this.$refs.courseDataForm.reset();
			// 		console.log('watch');
			// 		if (this.course != null) this.syncCourseProp();
			// 		else this.$refs.courseDataForm.reset();
			// 	},
			// 	deep: true
			// },
			name() {
				this.name = this.name.toUpperCase();
			}
		},

		computed: {
			
		},

		async mounted() {
			// this.isLoadingCourse = true;

			// Local or production?
			// this.getEnv();

			if (this.course != null) this.syncCourseProp();
			await this.getCategories();

			// this.isLoadingCourse = false;
		},

		methods: {
			// getEnv() {
			// 	return axios.get('/env')
			// 	.then(res => {
			// 		this.env = res.data;
			// 	});
			// },
			logga(value) {
				console.log(this.dateOfGraduation);
			},
			closeCourseDialog() {
				this.$emit('close-dialog');
			},
			getCategories() {
				this.isLoadingCategories = true;
				return axios.get('categorie')
				.then(res => {
					this.categories = res.data.map(category => {
						return {
							Nome: category.Nome,
							idCategoria: category.idCategoria,
						}
					});
					// se i nomi sono diversi uso map()
				})
				.finally(() => {
					this.isLoadingCategories = false;
				})
			},
			syncCourseProp() {
				this.name = this.course.Nome;
				this.category = {
					idCategoria: this.course.idCategoria,
					Nome: this.course.nomeCategoria,
				};
				// this.note = this.course.Note
			},
			validateForm(ref) {
				return this.$refs[ref].validate();
			},
			openSaveCourseDialog() {
				const isValid = this.validateForm('courseDataForm');
				if (!isValid) return;
				
				/**
				 * Imposto this.courseSaved = false in questo punto perchè se lo faccio nella funzione 
				 * closeSaveCourseDialog() si instravedono i bottoni poco prima della chiusura del dialog
				 */
				this.courseSaved = false;
				this.saveCourseDialog = true;
			},
			closeSaveCourseDialog() {
				this.saveCourseDialog = false;
				this.$emit('reload-table');
			},
			saveCourse() {
				this.isSavingCourse = true;
				// setTimeout(() => {
				// 	this.isSavingCourse = false;
				// 	this.courseSaved = true;
				// }, 2000);
				// return;

				let data = {};

				data['categoryId'] = this.category.idCategoria;
				data['name'] = this.name;
				// data['note'] = this.note;

				// console.log(data);

				if (this.course != null) { // sto modificando un corso
					axios.patch(`/corsi/${this.course.idCorso}`, data)
					.then(res => {
						this.isSavingCourse = false;
						this.courseSaved = true;
					})
					.catch(error => {
							// this.$vueEventBus.$emit('showAlert', 'error', 'Errore nel caricamento delle associazioni');
					})
					.finally(() => {
						// 
					});
				}
				else if (this.course == null) { // sto aggiungendo un nuovo corso
					axios.post('/corsi', data)
					.then(res => {
						this.isSavingCourse = false;
						this.courseSaved = true;
					})
					.catch(error => {
							// this.$vueEventBus.$emit('showAlert', 'error', 'Errore nel caricamento delle associazioni');
					})
					.finally(() => {
						//
					});
				}
			},
			openDeleteCourseDialog() {
				/**
				 * Imposto this.courseSaved = false in questo punto perchè se lo faccio nella funzione 
				 * closeSaveCourseDialog() si instravedono i bottoni poco prima della chiusura del dialog
				 */
				this.courseDeleted = false;
				this.deleteCourseDialog = true;
			},
			closeDeleteCourseDialog() {
				this.deleteCourseDialog = false;
				this.$emit('reload-table');
			},
			deleteCourse() {
				this.isDeletingCourse = true;
				axios.delete(`/corsi/${this.course.idCorso}`)
				.then(res => {
					this.isDeletingCourse = false;
					this.courseDeleted = true;
				})
				.catch(error => {

				})
				.finally(() => {
					// 
				})
			}
		},
	}
</script>

<style lang="scss" scoped>

</style>